import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { APP_CONFIG, EnvironmentModel } from '@fh-client-interaction-frontends/fh-app-config';
import { TranslateService } from '@ngx-translate/core';

const ignoreHeadersTokenUrls = ['/medicalnetwork'];

export const cpHeadersInterceptor: HttpInterceptorFn = (req, next) => {
  const appConfig: EnvironmentModel = inject(APP_CONFIG) as EnvironmentModel;
  const translateService = inject(TranslateService);

  if (req.headers.has('X-Internal-CTO')) {
    req = req.clone({ headers: req.headers.delete('X-Internal-CTO', '1') });
  }
  if (req.headers.has('X-Internal-SGHA')) {
    req = req.clone({ headers: req.headers.delete('X-Internal-SGHA', '1') });
  }
  // req = req.clone({headers: req.headers.set('X-IntegrationKey', new Date().getTime().toString())});
  req = req.clone({
    headers: req.headers.set('X-Partnership', appConfig.apiPartnershipId)
  });
  req = req.clone({ headers: req.headers.set('Accept', 'application/json') });
  req = req.clone({
    headers: req.headers.set('X-Language', translateService.currentLang || '')
  });
  // req = req.clone({headers: req.headers.set('X-Partnershipapilink:', appConfig.apiPartnershipIdLink || '')});

  if (req.url.includes(appConfig.api)) {
    if (sessionStorage.getItem('token') && !ignoreHeadersTokenUrls.includes(req.url.split(appConfig.platform)[1]) && !req.url.includes('/medicalnetwork')) {
      req = req.clone({
        headers: req.headers.set('Authorization', 'Bearer ' + sessionStorage.getItem('token'))
      });
    }
  }

  return next(req);
};
